/** Changes whenever what the review shows could be stale: settings, files, items, their types, pools and sheet writes. */
export const reviewSignature = (draft: {
  fileOrder: string[]
  groups: Record<
    string,
    {
      item: { itemId?: string; itemType?: string; poolId?: string; status: string }
      itemType?: string
      pool?: number
      applied?: { status: string; sheetKey?: string; primerSource?: string }
      manualPrimers?: { forward?: string; reverse?: string }
    }
  >
  sheet?: { fileKey: string; revision: number }
  settings?: { targetTaxonomy: { value: string }; processingType: { value: string }; allowSingletons: boolean }
}): string =>
  JSON.stringify([
    draft.fileOrder.length,
    draft.settings ? [draft.settings.targetTaxonomy.value, draft.settings.processingType.value, draft.settings.allowSingletons] : '',
    draft.sheet ? `${draft.sheet.fileKey}#${draft.sheet.revision}` : '',
    Object.entries(draft.groups).map(([key, group]) => [
      key,
      group.item.status,
      group.item.itemId,
      group.item.itemType,
      group.item.poolId,
      group.itemType,
      group.pool,
      group.applied?.status,
      group.applied?.sheetKey,
      group.applied?.primerSource,
      group.manualPrimers?.forward,
      group.manualPrimers?.reverse
    ])
  ])
